/**
 * @function encodeBasicAuthCredentials
 * @description
 * Encodes a pair of username and password into a base64 encoded
 * string, which is the format used by the HTTP Basic Auth header.
 * @param {Object} options - A plain object with the following properties:
 * @param {string} [options.username=''] - The username to encode.
 * @param {string} [options.password=''] - The password to encode.
 * @returns {string} A base64 encoded string.
 */
export default function encodeBasicAuthCredentials({
  username = '',
  password = ''
}) {
  const credentials = `${username}:${password}`;
  if (typeof window !== 'undefined' && window.btoa) {
    return window.btoa(credentials);
  } else {
    return Buffer.from(credentials).toString('base64');
  }
}
